/**
 * Добывает имя аутентифицированного пользователя
 */
export function getName(firstName?: string, lastName?: string): string {
  switch (true) {
    case firstName !== undefined && lastName !== undefined:
      return `${firstName} ${lastName}`;
    case firstName !== undefined:
      // tslint:disable-next-line:no-non-null-assertion
      return firstName!;
    case lastName !== undefined:
      // tslint:disable-next-line:no-non-null-assertion
      return lastName!;
    default:
      return 'имя не указано';
  }
}
